package com.partejar.app

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.partejar.app.core.di.initKoin
import com.partejar.app.core.di.PRODUCTION_API_BASE_URL
import com.partejar.app.feature.convite.presentation.PublicWebLinkParser
import com.partejar.app.feature.convite.presentation.PublicWebLinkRoute
import com.partejar.app.feature.account.presentation.PublicAccountDeletionScreen
import com.partejar.app.core.ui.theme.PartejarTheme
import kotlinx.browser.window

private const val LOCAL_API_BASE_URL = "http://localhost:8080"
private const val STAGING_API_BASE_URL = "http://partejar-api-staging.localho.st:18088"

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    initKoin(apiBaseUrl = apiBaseUrlForHost(window.location.hostname))
    val route = PublicWebLinkParser.routeFrom(window.location.href)
    if (route != PublicWebLinkRoute.Normal) {
        window.history.replaceState(null, "", window.location.origin + window.location.pathname)
    }
    ComposeViewport {
        if (window.location.pathname.trimEnd('/') == "/excluir-conta") {
            window.document.title = "Excluir conta | Partejar"
            var signInRequested by remember { mutableStateOf(false) }
            if (signInRequested) {
                App(startAccountDeletion = true)
            } else {
                PartejarTheme {
                    PublicAccountDeletionScreen(onSignIn = { signInRequested = true })
                }
            }
        } else {
            when (route) {
                is PublicWebLinkRoute.Invite -> App(inviteLink = route.link)
                is PublicWebLinkRoute.Signature -> App(publicSignatureToken = route.token)
                PublicWebLinkRoute.Normal -> App()
            }
        }
    }
}

private fun apiBaseUrlForHost(hostname: String): String =
    if (hostname.equals("localhost", ignoreCase = true)) {
        LOCAL_API_BASE_URL
    } else if (hostname.equals("partejar-web-staging.localho.st", ignoreCase = true)) {
        STAGING_API_BASE_URL
    } else {
        PRODUCTION_API_BASE_URL
    }
